import type { DeviceTier } from '@/types';

export interface DeviceCapabilities {
  tier: DeviceTier;
  webgpuSupported: boolean;
  canvas2dSupported: boolean;
  estimatedRAM: number;
  cpuCores: number;
}

export function detectDeviceCapabilities(): DeviceCapabilities {
  const cpuCores = navigator.hardwareConcurrency || 2;

  // Estimate RAM (rough heuristic)
  const estimatedRAM =
    // @ts-expect-error deviceMemory is non-standard
    navigator.deviceMemory || (cpuCores >= 8 ? 8 : cpuCores >= 4 ? 4 : 2);

  // Check WebGPU
  const webgpuSupported = typeof navigator !== 'undefined' && 'gpu' in navigator;

  // Check Canvas 2D (required for image display)
  const canvas2d = document.createElement('canvas');
  const canvas2dSupported = !!canvas2d.getContext('2d');

  // Tier assignment
  let tier: DeviceTier = 'D';
  if (webgpuSupported && estimatedRAM >= 4) {
    tier = 'A';
  } else if (canvas2dSupported && estimatedRAM >= 3) {
    tier = 'B';
  } else if (canvas2dSupported) {
    tier = 'C';
  }

  return {
    tier,
    webgpuSupported,
    canvas2dSupported,
    estimatedRAM,
    cpuCores,
  };
}
